module.exports = __webpack_public_path__ + "img/IMG_5482.bdc78549.jpg";